// extracted by css-extract-rspack-plugin
export default {"labelCenter":"labelCenter-s4TXFS","yAxisLabel":"yAxisLabel-v8ldFg"};